<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <v-card-text>
                    <h1>List users</h1>
                    <hr>
                    <v-layout>
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <v-btn fab small color="primary" @click="showAdd" v-on="on"><v-icon>add</v-icon></v-btn>
                            </template>
                            <span>Add new user</span>
                        </v-tooltip>
                    </v-layout>
                    <v-dialog v-model="showNewSales" persistent max-width="400px">
                        <v-card>
                            <v-card-title class="headline">Create User</v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field label="Enter your E-mail" ref="focusEmail" v-model="email" :rules="emailRules" required
                                                @keypress.enter="sendEmail">
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field label="Enter your Password" v-model="password" :append-icon="hidePass ? 'visibility' : 'visibility_off'"
                                                :append-icon-cb="() => (hidePass = !hidePass)" :type="hidePass ? 'password' : 'text'" 
                                                :rules="passwordRules" required @keypress.enter="login" ref="focusPass">
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click="cancelNewSales">Cancel</v-btn>
                                <v-btn color="blue darken-1" flat @click="addNewSales">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <hr>
                    <v-data-table :headers="headers" :items="detail[0]" class="elevation-1" v-bind:pagination.sync="pagination">
                        <template v-slot:no-data>
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        </template>
                        <template v-slot:items="props">
                            <td>{{props.item.email}}</td>
                            <td>{{props.item.isAdmin = props.item.custom==null || props.item.custom.admin==false?'User':'Admin'}}</td>
                            <td class="justify-center layout px-0">
                                <v-tooltip right v-if="props.item.isAdmin == 'User'">
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-1" @click="addAdmin(props.item)" v-on="on">person</v-icon>
                                    </template>
                                    <span>Change to admin</span>
                                </v-tooltip>
                                <v-tooltip right v-if="props.item.isAdmin == 'Admin'">
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-1" @click="changeUser(props.item)" v-on="on">person_outline</v-icon>
                                    </template>
                                    <span>Change to user</span>
                                </v-tooltip>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-1" @click="deleteSales(props.item)" v-on="on">delete</v-icon>
                                    </template>
                                    <span>Delete this e-mail</span>
                                </v-tooltip>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {functions} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'

export default {
    components: {
        mainMenu
    },
    data(){
        return{
            detail: [],
            valid: false,
            hidePass: true,
            showNewSales: false,
            email: '',
            password: '',
            emailRules: [
              (v) => !!v || 'E-mail is required',
              (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                (v) => !!v || 'Password is required',
                (v) => v.length > 5 || 'Password should be at least 6 characters'
            ],

            headers:[
                { text: 'E-mail', align: 'left', value: 'email' },
                { text: 'Status', sortable: false, align: 'left' },
                { text: '', sortable: false, align: 'left' }
            ],
            pagination: {'sortBy': 'email', 'descending': false},
            userUid: ''
        }
    },
    methods:{
        getUser(){
            this.detail = []
            const listUser = functions.httpsCallable('listAllUser')
            listUser().then((doc) => {
                // console.log(doc)
                this.detail.push(doc.data.userlist)
            })
        },
        showAdd(){
            this.showNewSales = true
            this.$nextTick(()=>{this.$refs.focusEmail.focus()})
        },
        cancelNewSales(){
            this.showNewSales = false
            this.email = ''
            this.password = ''
        },
        addNewSales(){
            if(this.email == '' || this.email == this.email.replace(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)){
                this.$nextTick(()=>{this.$refs.focusEmail.focus()})
            }
            else if(this.password.length < 6 || this.password == ''){
                this.$nextTick(()=>{this.$refs.focusPass.focus()})
            }
            else{
                const newUser = functions.httpsCallable('newUser')
                newUser({ email: this.email, password: this.password})
                .then(() => {
                    alert("Add new user successfully.")
                    this.cancelNewSales()
                    this.getUser()
                    
                })
                .catch(error=>{
                    alert(error)
                })
            }
        },
        addAdmin(item){
            let adminEmail = item.email
            if(confirm("Do you want to set this e-mail: " + adminEmail + " as an administrator?") == true){
                const addAdminRole = functions.httpsCallable('addAdminRole')
                addAdminRole({ email: adminEmail })
                .then(() => {
                    alert("Success.")
                    this.getUser()
                })
                .catch(error=>{
                    alert(error)
                })
            }
            else{
                return
            }
        },
        changeUser(item){
            let adminEmail = item.email
            if(confirm("Do you want to set this e-mail: " + adminEmail + " as an user?") == true){
                const addUserRole = functions.httpsCallable('addUserRole')
                addUserRole({ email: adminEmail })
                .then(() => {
                    alert("Success.")
                    this.getUser()
                })
                .catch(error=>{
                    alert(error)
                })
            }
            else{
                return
            }
        },
        deleteSales(item){
            this.email = item.email
            if(confirm("Do you want to delete this e-mail: " + item.email + " ?") == true){
                const deleteUsers = functions.httpsCallable('deleteUsers')
                deleteUsers({ email: this.email })
                .then(()=>{
                    alert("Delete user successfully.")
                    this.getUser()
                })
                .catch(error=>{
                    alert(error)
                })
            }
            else{
                return
            }
        },
    },
    mounted(){
        this.getUser()
    }
}
</script>
